import type { EntityState } from '@core/ngrx-legacy';
import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type { ReportDashboardMetricOptions } from '@core/reports-types';

import { reportsStoreFeatureName } from '../consts';

// import { safeReportsStateSelector } from '../helpers/safe-reports-state-selector';

export const safeReportsStateSelector = (state: any, namespace: string, initilalState: any) => {
  const reportsState = reportsStoreFeatureName in state ? state[reportsStoreFeatureName] : null;
  if (reportsState && namespace in reportsState) {
    return reportsState[namespace];
  }
  return initilalState;
};

// TODO see how it works
const namespace = 'ReportsMetrics';

const { actions, selectors, reducer, initialState } =
  createEntityCollectionStore<ReportDashboardMetricOptions>()(namespace, {
    baseSelector: (root): EntityState<ReportDashboardMetricOptions> =>
      safeReportsStateSelector(root, namespace, initialState),
    idSelector: (metric: ReportDashboardMetricOptions) => metric.metric,
    customActions: adapter => ({
      resetAll: state => adapter.resetAll(state),
    }),
  });

export {
  actions as ReportsMetricsActions,
  namespace as ReportsMetricsNamespace,
  reducer as ReportsMetricsReducer,
  selectors as ReportsMetricsSelectors,
};
